var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFile = function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.696 4.7c-.638 0-1.25.254-1.702.705L5.86 12.539a3.96 3.96 0 0 0 5.6 5.601l7.63-7.63.99.99-7.63 7.63a5.36 5.36 0 1 1-7.58-7.58l7.134-7.135A3.807 3.807 0 0 1 17.388 9.8l-7.142 7.134a2.254 2.254 0 0 1-3.187-3.187l7.087-7.078.989.99-7.086 7.078a.853.853 0 1 0 1.207 1.207l7.142-7.134A2.408 2.408 0 0 0 14.696 4.7",
    clipRule: "evenodd"
  })));
};
export default SvgFile;